import React from 'react';
import { toast } from 'react-hot-toast';
import './UserDashboard.css';

// Mock menu data for preview
const mockMenuItems = [
  {
    _id: 'mock-1',
    title: 'Creamy Tomato Pasta',
    description: 'A delicious homemade pasta dish with a rich tomato cream sauce',
    image: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400'
  },
  {
    _id: 'mock-2',
    title: 'Grilled Chicken Salad',
    description: 'Fresh mixed greens with tender grilled chicken and balsamic vinaigrette',
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400'
  },
  {
    _id: 'mock-3',
    title: 'Vegetable Stir Fry',
    description: 'Colorful mix of fresh vegetables in a savory Asian-inspired sauce',
    image: 'https://images.unsplash.com/photo-1512058564366-18510be2db19?w=400'
  }
];

const MyMenusPreview = () => {
  const handleFeatureClick = (featureName) => {
    toast.error(`Please sign in to ${featureName}`, {
      duration: 3000,
      icon: '🔒',
    });
  };

  return (
    <div className="my-menus-preview-wrapper">
      <div className="preview-banner">
        <i className="fas fa-info-circle"></i>
        <span>Sign in to create and manage your personal recipe collection</span>
      </div>

      <div className="user-dashboard preview-mode">
        <div className="dashboard-header">
          <h1>My Personal Menus</h1>
          <div className="menu-limit-indicator">
            <span className="menu-count preview-text">
              Sign in to track your menu usage
            </span>
          </div>
        </div>

        <div className="dashboard-actions">
          <div className="action-buttons">
            <button 
              className="add-menu-button disabled-preview"
              onClick={() => handleFeatureClick('add new menus')}
            >
              + Add New Menu
            </button>
            <button 
              className="extract-menu-button disabled-preview"
              onClick={() => handleFeatureClick('extract recipes from URLs')}
            >
              + Extract from URL
            </button>
          </div>
          <div className="user-menu-search-container">
            <input
              type="text"
              placeholder="Search your menus..."
              className="user-menu-search-input disabled-preview"
              disabled
              onClick={() => handleFeatureClick('search menus')}
            />
          </div>
        </div>

        <div className="menu-items-grid">
          {mockMenuItems.map(item => (
            <div key={item._id} className="menu-item-card preview-card">
              <div className="preview-overlay" onClick={() => handleFeatureClick('view menu details')}>
                <i className="fas fa-lock"></i>
                <span>Sign in to view</span>
              </div>
              <div className="personal-badge">Personal Menu</div>
              <img 
                src={item.image} 
                alt={item.title} 
                className="item-image"
              />
              <div className="item-details">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <div className="item-actions">
                  <button
                    onClick={() => handleFeatureClick('view details')}
                    className="view-button disabled-preview"
                  >
                    View Details
                  </button>
                  <button
                    onClick={() => handleFeatureClick('edit menus')}
                    className="edit-button disabled-preview"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleFeatureClick('delete menus')}
                    className="delete-button disabled-preview"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="preview-cta">
          <h2>Ready to start building your recipe collection?</h2>
          <p>Sign in to upload your favorite recipes and use our platform to easily order ingredients!</p>
        </div>
      </div>
    </div>
  );
};

export default MyMenusPreview;

